import './ContactForm.scss';
import emailjs from '@emailjs/browser';
import {useRef, useState} from 'react';
import SubmitMessage from './SubmitMessage'

export default function ContactForm(){

    const public_key = process.env.REACT_APP_KEY;
    const tamplate= process.env.REACT_APP_TAMPLATE_ID;
    const service = process.env.REACT_APP_SERVICE_ID;
     const myKey = process.env.REACT_APP_MY_SECRET_KEY;

    async function postClientData(name, phone){
        const data = {
            app_code: 6,
            key: myKey,
            master: 27074,
            franch_id: 130,
            name,
            phone,
            comment: 'Лід з сайту SmartumPro'

        }

        const formBody = new URLSearchParams(data).toString();

        try{
            const response = await fetch(' https://platform-smartum.com.ua/api/add_lead_post', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: formBody
            })

            const result = await response.json()

            console.log(result)
        } catch(err) {
            console.error('ErrorMassage', err)
        }

        
    }

    const form = useRef();
    const [msg, setMsg] = useState(false)

    function ressetFormData(){
        form.current.name.value = "";
        form.current.number.value = "";
        form.current.course.value = "";
        form.current.format.value = "";
    }

    const successSubmit = () => {
        setMsg(true)
        ressetFormData()
        
       setTimeout(() => {
        setMsg(false);
       }, 3000);
        
    }

    const sendEmail = (e) => {
        e.preventDefault();
    
        emailjs
          .sendForm(service, tamplate, form.current, {
            publicKey: public_key,
          })
          .then(
            () => {
              console.log('SUCCESS!');
              postClientData(form.current.name.value, form.current.number.value)
              successSubmit()
              
            },
            (error) => {
              console.log('FAILED...', error.text);
            },
          );
      };

    return(
        <div className="ContactForm">
            <div className="wrapper">
            <h2>Запрошуємо на безкоштовне перше заняття!</h2>
                <form ref={form} onSubmit={sendEmail}>
                   

                    <div className="name">
                        <label htmlFor="name">Ім'я</label>
                        <input name='name' type="text" id="name" placeholder="" required />
                    </div>
                    <div className="number">
                        <label htmlFor="number">Номер телефону</label>
                        <input name='number' type="tel" id="number" placeholder="" required />
                    </div>
                    <div className="programm">
                     <label htmlFor="programm">Курс</label>
                        <select name="course" id="programm">
                            <option value="">Оберіть курс</option>
                            <option value="МА">Ментальна арифметика</option>
                            <option value="ПДШ">Підготовка до школи</option>
                            <option value="Чит">Розвиток читання</option>
                            <option value="Англ">Англійська мова</option>
                            <option value="Мем">Меморика</option>
                            <option value="Амам">Амаматика</option>
                            <option value="ТМО">Таблиця множення онлайн</option>
                        </select>
                    </div>
                    <div className="format">
                        <label htmlFor="format">Формат занять</label>
                        <select name="format" id="format">
                            <option value="">Оберіть формат занять</option>
                            <option value="online">Онлайн</option>
                            <option value="Izmail">Ізмаїл</option>
                            <option value="B-D">Білгород-Дністровський</option>
                        </select>
                    </div>
                    <div>
                        <input className='btn' type="submit" value={"Відправити"} />
                    </div>
                </form>
            </div>
          
            {msg && <SubmitMessage />}
            
        </div>

    )
}